import { render, staticRenderFns } from "./cms-block-qr-scanner.vue?vue&type=template&id=2a2f58c8&scoped=true"
import script from "./cms-block-qr-scanner.vue?vue&type=script&lang=js"
export * from "./cms-block-qr-scanner.vue?vue&type=script&lang=js"
import style0 from "./cms-block-qr-scanner.vue?vue&type=style&index=0&id=2a2f58c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f58c8",
  null
  
)

export default component.exports